import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconClose = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={'icon-close' + (className ? ` ${className}` : '')}
            fill='none'
            height='10'
            viewBox='0 0 10 10'
            width='10'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M4.50188 5.29L0.941051 8.85104C0.825634 8.96632 0.701398 9.02188 0.568343 9.01771C0.435426 9.0134 0.308551 8.9509 0.187718 8.83021C0.0670236 8.70938 0.00667631 8.58035 0.00667631 8.44313C0.00667631 8.3059 0.0670236 8.17688 0.187718 8.05604L3.72793 4.51604L0.166885 0.955209C0.0516069 0.839792 -0.00394864 0.712084 0.000218023 0.572084C0.00452358 0.432223 0.0670236 0.301875 0.187718 0.181042C0.308551 0.0603473 0.437579 0 0.574801 0C0.712023 0 0.841051 0.0603473 0.961884 0.181042L4.50188 3.74208L8.06272 0.181042C8.17813 0.0657639 8.30584 0.00673616 8.44584 0.00395838C8.5857 0.0013195 8.71605 0.0603473 8.83689 0.181042C8.95758 0.301875 9.01793 0.430903 9.01793 0.568125C9.01793 0.705348 8.95758 0.834376 8.83689 0.955209L5.27584 4.51604L8.83689 8.07688C8.95216 8.19229 9.01119 8.31653 9.01397 8.44958C9.01661 8.5825 8.95758 8.70938 8.83689 8.83021C8.71605 8.9509 8.58702 9.01125 8.4498 9.01125C8.31258 9.01125 8.18355 8.9509 8.06272 8.83021L4.50188 5.29Z'
                fill={fill}/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconClose;
